var map = {
	"./com-bangzhu.svg": "b9ca",
	"./com-gonggao.svg": "b016",
	"./com-shelijigou.svg": "12ee",
	"./com-shequ.svg": "76c9",
	"./custom-case.svg": "01e9",
	"./custom-community.svg": "9a52",
	"./custom-event.svg": "66ab",
	"./dietaryNutrition.svg": "42ba",
	"./exercise.svg": "b07c",
	"./healthAssessment.svg": "f846",
	"./healthGuidance.svg": "ac08",
	"./healthInsurance.svg": "302e",
	"./materialLibrary.svg": "8596",
	"./monitoringFollowup.svg": "37eb7",
	"./physicalExamination.svg": "0769",
	"./psychologicalIntervention.svg": "1046",
	"./test.svg": "fe8d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";